import { render, staticRenderFns } from "./LabelsFilters.vue?vue&type=template&id=9899d564"
import script from "./LabelsFilters.vue?vue&type=script&lang=js"
export * from "./LabelsFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports